import { cn, initials } from "@core/utils";

type AvatarSize = "sm" | "md" | "lg";

interface AvatarProps {
  /** Full name; the initials are derived from it. */
  name: string;
  size?: AvatarSize;
  className?: string;
}

const SIZE: Record<AvatarSize, string> = {
  // 32px: top bar and team row. 40px: the sidebar account card. 44px: the profile page.
  sm: "size-8 text-xs-semibold",
  md: "size-10 text-sm-semibold",
  lg: "size-11 text-md-semibold",
};

/**
 * Initials in a soft menthe circle. Initials only, never a photo: the profile carries no avatar
 * URL and no story asks for one. Decorative, because the name always sits next to it.
 */
export function Avatar({ name, size = "sm", className }: AvatarProps) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full bg-menthe-100 text-menthe-800",
        SIZE[size],
        className
      )}
    >
      {initials(name)}
    </span>
  );
}

export type { AvatarProps, AvatarSize };
